import useJwt from '@core/auth/jwt/useJwt'
import axios from '@axios'
import { REST_ENDPOINT } from '../../../endpoints';

axios.defaults.baseURL = REST_ENDPOINT;

const { jwt } = useJwt(axios, {
  // Endpoints
  loginEndpoint: '/api/v1/offsite-users/tokens',
  loginMagicLinkEndpoint: '/api/v1/offsite-users/tokens/magic-link',
  // refreshEndpoint: '/refresh-token',
  // logoutEndpoint: '/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'userTokenOffsite',
  storageRefreshTokenKeyName: 'refreshTokenCell',
})
export default jwt
